import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'globot-profile-picture',
  template: ` <div
      class="profile-picture"
      [style.background-color]="backgroundColor"
      *ngIf="!imageUrl"
      [style.width.px]="size"
      [style.height.px]="size"
      [style.font-size.px]="fontSize"
    >
      {{ initial }}
    </div>
    <img
      *ngIf="imageUrl"
      [src]="imageUrl"
      alt="Profile picture"
      class="profile-picture"
      [style.width.px]="size"
      [style.height.px]="size"
    />`,
  styleUrls: ['./profile-picture.component.scss'],
})
export class ProfilePictureComponent implements OnInit {
  @Input() name: string = '';
  @Input() imageUrl: string | null = null;
  @Input() size: number = 32;

  initial: string = '';
  backgroundColor: string = '#B869DE'; // Color fijo
  fontSize = 16;

  ngOnInit() {
    this.initial = this.name ? this.name.charAt(0).toUpperCase() : ''; // Maneja caso de string vacío
    this.fontSize = this.size / 2;
  }
  //Método comentado para generar colores aleatorios
  // Este método está desactivado y se usa un color fijo por ahora
  /* getRandomColor(): string {
  // NOSONAR
     const letters = '0123456789ABCDEF';
     let color = '#';
     for (let i = 0; i < 6; i++) {
       color += letters[Math.floor(Math.random() * 16)];
     }
     return color;
   }*/
}
